/**
 * Vista inversa de la pivot `service_staff` desde el StaffModal del superadmin.
 * Muestra el catálogo global y permite marcar qué servicios ofrece el staff.
 * La pivot es la misma que se gestiona desde el ServiceModal — esta es la
 * lectura/edición desde el otro lado.
 */
import type { Service } from '@api/types';

interface StaffServicesSectionProps {
  allServices: readonly Service[];
  selectedIds: ReadonlySet<string>;
  loaded: boolean;
  onToggle: (serviceId: string) => void;
}

export function StaffServicesSection({
  allServices,
  selectedIds,
  loaded,
  onToggle,
}: StaffServicesSectionProps) {
  return (
    <div className="field" style={{ marginTop: 16, paddingTop: 14, borderTop: '1px solid var(--border)' }}>
      <label className="field-label">Servicios que ofrece</label>
      <p style={{ fontSize: 11.5, color: 'var(--fg-soft)', margin: '0 0 8px' }}>
        Catálogo global. Marca los servicios que este profesional sabe hacer — aparecerán
        en el widget de los centros donde esté dado de alta y tenga horario configurado.
      </p>
      {!loaded && (
        <p style={{ fontSize: 12, color: 'var(--fg-muted)' }}>Cargando servicios…</p>
      )}
      {loaded && allServices.length === 0 && (
        <p style={{ fontSize: 12, color: 'var(--fg-muted)' }}>
          Aún no hay servicios en el catálogo global.
        </p>
      )}
      {loaded && allServices.length > 0 && (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 6, maxHeight: 220, overflowY: 'auto', border: '1px solid var(--border)', borderRadius: 'var(--radius-sm)', padding: 8 }}>
          {allServices.map((svc) => (
            <label key={svc.id} style={{ display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer', fontSize: 13 }}>
              <input
                type="checkbox"
                checked={selectedIds.has(svc.id)}
                onChange={() => { onToggle(svc.id); }}
                style={{ width: 14, height: 14, accentColor: 'var(--accent)' }}
              />
              <span>{svc.name}</span>
              {svc.category && (
                <span style={{ fontSize: 11, color: 'var(--fg-soft)' }}>· {svc.category}</span>
              )}
              {!svc.active && (
                <span className="pill" data-tone="neutral" style={{ marginLeft: 4 }}>Inactivo</span>
              )}
            </label>
          ))}
        </div>
      )}
      {loaded && allServices.length > 0 && selectedIds.size === 0 && (
        <p style={{ fontSize: 12, color: 'var(--fg-soft)', marginTop: 6 }}>
          Sin servicios marcados → este profesional no aparecerá como capaz de ningún servicio.
        </p>
      )}
    </div>
  );
}
